module.exports = __webpack_public_path__ + "static/media/work-2.4956fef7.png";